"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ticket_1 = require("./ticket");
var TicketOptions = (function () {
    function TicketOptions(chosenBalls, api) {
        this.topColor = [];
        this.ballParity = 0;
        this.first5Sum = 0;
        this.firstBallColor = [];
        this.firstBallParity = 0;
        this.firstBallSum = 0;
        this.lastBallColor = [];
        this.lastBallParity = 0;
        this.lastBallSum = 0;
        this.lastBet = false;
        this.colors = {
            'red': 1,
            'green': 2,
            'blue': 3,
            'purple': 4,
            'brown': 5,
            'yellow': 6,
            'orange': 7,
            'black': 8
        };
        this.colorsInversed = {
            1: 'red',
            2: 'green',
            3: 'blue',
            4: 'purple',
            5: 'brown',
            6: 'yellow',
            7: 'orange',
            8: 'black'
        };
        this.chosenBalls = chosenBalls;
        this.api = api;
    }
    TicketOptions.prototype.getFirst5Sum = function () {
        return this.first5Sum;
    };
    TicketOptions.prototype.getBallParity = function () {
        return this.ballParity;
    };
    TicketOptions.prototype.color2number = function (color) {
        return this.colors[color];
    };
    TicketOptions.prototype.getTopColor = function () {
        var topColor = [];
        for (var key in this.topColor) {
            topColor.push(this.color2number(this.topColor[key]));
        }
        topColor.sort();
        var colors = topColor.join('');
        return colors;
    };
    TicketOptions.prototype.getFirstBallColor = function () {
        var firstBallColor = [];
        for (var key in this.firstBallColor) {
            firstBallColor.push(this.color2number(this.firstBallColor[key]));
        }
        firstBallColor.sort();
        var colors = firstBallColor.join('');
        return colors;
    };
    TicketOptions.prototype.getFirstBallParity = function () {
        return this.firstBallParity;
    };
    TicketOptions.prototype.getFirstBallSum = function () {
        return this.firstBallSum;
    };
    TicketOptions.prototype.getLastBallColor = function () {
        var lastBallColor = [];
        for (var key in this.lastBallColor) {
            lastBallColor.push(this.color2number(this.lastBallColor[key]));
        }
        lastBallColor.sort();
        var colors = lastBallColor.join('');
        return colors;
    };
    TicketOptions.prototype.getLastBallParity = function () {
        return this.lastBallParity;
    };
    TicketOptions.prototype.getLastBallSum = function () {
        return this.lastBallSum;
    };
    TicketOptions.prototype.getChosenBalls = function () {
        return this.chosenBalls;
    };
    TicketOptions.prototype.getAmount = function () {
        return $('#betting-btn').val();
    };
    TicketOptions.prototype.getSubscriptions = function () {
        return $('#subscription-btn').val();
    };
    TicketOptions.prototype.setTopColor = function (color) {
        if (this.topColor.indexOf(color) == -1) {
            this.topColor.push(color);
        }
    };
    TicketOptions.prototype.unsetTopColor = function (color) {
        if (this.topColor.indexOf(color) !== -1) {
            delete this.topColor[this.topColor.indexOf(color)];
        }
    };
    TicketOptions.prototype.setFirstBallColor = function (color) {
        if (this.firstBallColor.indexOf(color) == -1) {
            this.firstBallColor.push(color);
        }
    };
    TicketOptions.prototype.unsetFirstBallColor = function (color) {
        if (this.firstBallColor.indexOf(color) !== -1) {
            delete this.firstBallColor[this.firstBallColor.indexOf(color)];
        }
    };
    TicketOptions.prototype.setLastBallColor = function (color) {
        if (this.lastBallColor.indexOf(color) == -1) {
            this.lastBallColor.push(color);
        }
    };
    TicketOptions.prototype.unsetLastBallColor = function (color) {
        if (this.lastBallColor.indexOf(color) !== -1) {
            delete this.lastBallColor[this.lastBallColor.indexOf(color)];
        }
    };
    TicketOptions.prototype.repeatLast = function () {
        var lastBet = this.lastBet;
        if (false === lastBet) {
            return;
        }
        this.clearBets();
        $('#betting-btn').val(lastBet['TicketAmount']);
        if (Object.keys(lastBet['SelectedNumbers']).length > 10) {
            this.chosenBalls.allColors();
        }
        else {
            this.chosenBalls.addBalls(lastBet['SelectedNumbers']);
        }
        var topColors = this.decodeColors(lastBet['TopColor']);
        var firstColor = this.decodeColors(lastBet['FirstColor']);
        var lastColor = this.decodeColors(lastBet['LastColor']);
        this.applyColorBets('.top-color', topColors);
        this.applyColorBets('.first-ball-color', firstColor);
        this.applyColorBets('.last-ball-color', lastColor);
        if (lastBet['BallParity'] == 2) {
            $('#more-odd').trigger('click');
        }
        else if (lastBet['BallParity'] == 1) {
            $('#more-even').trigger('click');
        }
        if (lastBet['First5Sum'] == 1) {
            $('#first5lessthan122').trigger('click');
        }
        else if (lastBet['First5Sum'] == 2) {
            $('#first5morethan122').trigger('click');
        }
        if (lastBet['FirstBallParity'] == 1) {
            $('#firstballeven').trigger('click');
        }
        else if (lastBet['FirstBallParity'] == 2) {
            $('#firstballodd').trigger('click');
        }
        if (lastBet['FirstballSum'] == 1) {
            $('#firstballlessthan24').trigger('click');
        }
        else if (lastBet['FirstballSum'] == 2) {
            $('#firstballmorethan24').trigger('click');
        }
        if (lastBet['LastBallParity'] == 1) {
            $('#lastballeven').trigger('click');
        }
        else if (lastBet['LastBallParity'] == 2) {
            $('#lastballodd').trigger('click');
        }
        if (lastBet['LastBallSum'] == 1) {
            $('#lastballlessthan24').trigger('click');
        }
        else if (lastBet['LastBallSum'] == 2) {
            $('#lastballmorethan24').trigger('click');
        }
    };
    TicketOptions.prototype.applyColorBets = function (cssClass, colors) {
        $(cssClass).each(function (_index, element) {
            if (undefined !== element.dataset.color) {
                if (colors.indexOf(element.dataset.color) != -1) {
                    $(element).trigger('click');
                }
            }
        });
    };
    TicketOptions.prototype.decodeColors = function (colorString) {
        var colorArray = [];
        for (var i = 0; i < colorString.length; i++) {
            colorArray.push(this.number2color(parseInt(colorString.charAt(i))));
        }
        return colorArray;
    };
    TicketOptions.prototype.number2color = function (colorCode) {
        return this.colorsInversed[colorCode];
    };
    TicketOptions.prototype.saveLastBet = function () {
        this.lastBet = {
            'TicketAmount': this.getAmount(),
            'SelectedNumbers': this.getChosenBalls().getBalls(),
            'First5Sum': this.getFirst5Sum(),
            'BallParity': this.getBallParity(),
            'FirstBallParity': this.getFirstBallParity(),
            'FirstballSum': this.getFirstBallSum(),
            'LastBallParity': this.getLastBallParity(),
            'LastBallSum': this.getLastBallSum(),
            'TopColor': this.getTopColor(),
            'FirstColor': this.getFirstBallColor(),
            'LastColor': this.getLastBallColor()
        };
    };
    TicketOptions.prototype.clearBets = function () {
        this.topColor = [];
        this.ballParity = 0;
        this.first5Sum = 0;
        this.firstBallColor = [];
        this.firstBallParity = 0;
        this.firstBallSum = 0;
        this.lastBallColor = [];
        this.lastBallParity = 0;
        this.lastBallSum = 0;
        this.chosenBalls.removeAllBalls();
        $('#betting-btn').val(parseFloat(window['Bingo_MinBet']).toFixed(2));
        $('#betting-btn').attr('min', window['Bingo_MinBet']);
        $('#subscription-btn').val(1);
        $('#more-odd, #more-even, #first5lessthan122, #first5morethan122').removeClass('betting-btn-chosen');
        $('#firstballlessthan24, #firstballmorethan24, #firstballodd, #firstballeven').removeClass('betting-btn-chosen');
        $('#lastballodd, #lastballeven, #lastballlessthan24, #lastballmorethan24').removeClass('betting-btn-chosen');
        $('.top-color, .first-ball-color, .last-ball-color').each(function (_key, elem) {
            $(elem).removeClass('bhr-balls-choosen bhr-balls-choosen-' + elem.dataset.color);
        });
    };
    TicketOptions.prototype.validateTicket = function () {
        var translation = window['langArr'][window['language']];
        if ([0, 1, 2, 4].indexOf(Object.keys(this.topColor).length) === -1) {
            return { status: 0, message: translation['choose_1_2_4_common'] };
        }
        if ([0, 1, 2, 4].indexOf(Object.keys(this.firstBallColor).length) === -1) {
            return { status: 0, message: translation['choose_1_2_4_first'] };
        }
        if ([0, 1, 2, 4].indexOf(Object.keys(this.lastBallColor).length) === -1) {
            return { status: 0, message: translation['choose_1_2_4_last'] };
        }
        var amountInput = $('#betting-btn');
        if (amountInput !== undefined) {
            var amount = $(amountInput).val();
            var min = $(amountInput).attr('min');
            var max = $(amountInput).attr('max');
            if (undefined !== amount && undefined !== min && undefined !== max) {
                if (parseFloat(amount.toString()) < parseFloat(min.toString())) {
                    return { status: 0, message: translation['ticket_amount_less'] + min };
                }
                if (parseFloat(amount.toString()) > parseFloat(max.toString())) {
                    return { status: 0, message: translation['ticket_amount_more'] + max };
                }
            }
        }
        return { status: true, message: '' };
    };
    TicketOptions.prototype.showLoader = function () {
        var time = 0;
        var translation = window['langArr'][window['language']];
        $('#loaderWaitText').text(translation['please_wait']);
        $('#modalLoaderPercentage').text(time);
        $("#loadingModal").modal("show");
        var myTimer = setInterval(function () {
            time = parseInt($('#modalLoaderPercentage').text());
            if (time < 90) {
                time = time + 1;
            }
            else {
                clearInterval(myTimer);
            }
            $('#modalLoaderPercentage').text(time);
        }, 50);
        return myTimer;
    };
    TicketOptions.prototype.doBuy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!window['token']) return [3, 9];
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 7];
                        if (!(window['customLoggedIn'] && window['customToken'])) return [3, 1];
                        this.doBuyLogic();
                        return [3, 6];
                    case 1:
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this.getTokenPromise()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.saveLastBet();
                        this.clearBets();
                        $('#buy-ticket-button').removeAttr('disabled');
                        return [2];
                    case 5:
                        this.doBuyLogic();
                        _a.label = 6;
                    case 6: return [3, 8];
                    case 7:
                        $('#buy-ticket-button').removeAttr('disabled');
                        $('#loginModal').modal();
                        return [2];
                    case 8: return [3, 17];
                    case 9:
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 16];
                        if (!(window['customLoggedIn'] && !window['customToken'])) return [3, 14];
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4, this.getTokenPromise()];
                    case 11:
                        _a.sent();
                        return [3, 13];
                    case 12:
                        error_2 = _a.sent();
                        this.saveLastBet();
                        this.clearBets();
                        $('#buy-ticket-button').removeAttr('disabled');
                        return [2];
                    case 13:
                        this.doBuyLogic();
                        return [3, 15];
                    case 14:
                        this.doBuyLogic();
                        _a.label = 15;
                    case 15: return [3, 17];
                    case 16:
                        this.doBuyLogic();
                        _a.label = 17;
                    case 17: return [2];
                }
            });
        });
    };
    TicketOptions.prototype.doBuyLogic = function () {
        var self = this;
        var translation = window['langArr'][window['language']];
        $('#buy-ticket-button').attr('disabled', 'disabled');
        var ticket = new ticket_1.default(self);
        var timer = this.showLoader();
        self.api.send('/ticket/buy', ticket.getJSON(), function (response) {
            $('#buy-ticket-button').removeAttr('disabled');
            if (response['Status'] == 1) {
                if (/electron=true/.test(window.location.href)) {
                    window.parent.postMessage({
                        eventName: 'bought_ticket',
                        ticketData: ticket.getJSON(),
                        responseData: response
                    }, '*');
                }
                $('#modalLoaderPercentage').text("100");
                setTimeout(function () {
                    $("#loadingModal").modal("hide");
                    $('#buyTicketModal').modal();
                    if ("Data" in response) {
                        if ("BingoTicket" in response.Data) {
                            $('#boughtTicketId').html(" ID " + response.Data.BingoTicket[0].TicketID);
                        }
                    }
                }, 1000);
                clearInterval(timer);
                $("#loadingModal").modal("hide");
                $('#buyTicketModal').modal();
                if ("Data" in response) {
                    if ("BingoTicket" in response.Data) {
                        $('#boughtTicketId').html(" ID " + response.Data.BingoTicket[0].TicketID);
                    }
                }
                self.saveLastBet();
                self.clearBets();
                var ticketsEvent = new CustomEvent("get_tickets_no_stats");
                window.dispatchEvent(ticketsEvent);
                setTimeout(function () {
                    $('#buyTicketModal').modal('hide');
                    $('#boughtTicketId').html('');
                    $('.modal-backdrop').css('display', 'none');
                }, 2500);
            }
            else {
                setTimeout(function () {
                    $('#modalLoaderPercentage').text("100");
                    $("#loadingModal").modal("hide");
                    clearInterval(timer);
                }, 2000);
                if (response['ErrorText'] !== '') {
                    $('#modalErrorMessage').text(response['ErrorText']);
                }
                else {
                    $('#modalErrorMessage').text(translation['error_purchasing_ticket']);
                }
                $('#buyTicketError').modal('show');
            }
            var updateCreditEvent = new CustomEvent("get_credit");
            window.dispatchEvent(updateCreditEvent);
        }, function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        });
    };
    TicketOptions.prototype.getTokenPromise = function () {
        var tokenPromise = new Promise(function (resolve, reject) {
            window.addEventListener("message", function (event) {
                try {
                    if (JSON.parse(event.data).payload.action == 'login') {
                        window['customLoggedIn'] = true;
                        if (!JSON.parse(event.data).payload.token) {
                            reject(new Error('Empty Token Recieved'));
                        }
                        window['customToken'] = JSON.parse(event.data).payload.token;
                        resolve(window['customToken']);
                    }
                }
                catch (error) {
                    reject(error);
                }
            }, false);
            window['customToken'] ? resolve(window['customToken']) : '';
        });
        return tokenPromise;
    };
    TicketOptions.prototype.isJsonString = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    TicketOptions.prototype.attachListeners = function () {
        var _this = this;
        var self = this;
        window.addEventListener("message", function (event) {
            try {
                if (!_this.isJsonString(event)) {
                    var localResult = void 0;
                    try {
                        localResult = JSON.parse(event.data);
                    }
                    catch (err) { }
                    if (typeof localResult !== 'undefined' &&
                        JSON.parse(event.data).payload.action == 'customLogout') {
                        window['customLoggedIn'] = true;
                        window['customToken'] = '';
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
        }, false);
        $('body').on('click', '#repeat-last', function () {
            self.repeatLast();
        });
        $('body').on('click', '#confirmBuying', function () {
            var validation = self.validateTicket();
            if (validation.status !== true) {
                $('#chooseBetsError').text(validation.message);
                $('#chooseBetsModal').modal('show');
                return;
            }
            $('#buy-ticket-button').attr('disabled', 'disabled');
            $('#areYouSureModal').modal('hide');
            self.doBuy();
        });
        $('body').on('click', '#buy-ticket-button', function () {
            var validation = self.validateTicket();
            var translation = window['langArr'][window['language']];
            if (validation.status !== true) {
                $('#modalErrorMessage').text(validation.message);
                $('#buyTicketError').modal('show');
                return;
            }
            var amount = self.getAmount();
            var subscriptions = self.getSubscriptions();
            if (isNaN(subscriptions)) {
                $('#subscriptionModal').modal();
                return;
            }
            var calculation = parseFloat(amount) * parseInt(subscriptions);
            var displayAmount = Number(calculation.toFixed(2)).toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            if (window['purchaseConfirmation'] == 1) {
                $('#amountTitle').text(translation['amount']);
                $('#confirmAmount').text(displayAmount);
                $('#confirmCurrency').text(window['currency']);
                $('#buyingTitle').text(translation['buying_title']);
                $('#confirmBuying').text(translation['confirm_buying']);
                $('#cancelBuying').text(translation['cancel_buying']);
                $('#areYouSureModal').modal('show');
            }
            else {
                self.doBuy();
            }
        });
        $('body').on('click', '.abh-color', function () {
            self.chosenBalls.addAllByColor(this.dataset.color);
            self.updateMinBet();
        });
        $('body').on('click', '#min-bet', function () {
            $('#betting-btn').val(parseFloat(this.dataset.value).toFixed(2));
        });
        $('body').on('click', '#max-bet', function () {
            $('#betting-btn').val(parseFloat(this.dataset.value).toFixed(2));
        });
        $('body').on('click', '#bet-100', function () {
            $('#betting-btn').val(parseFloat(this.dataset.value).toFixed(2));
        });
        $('body').on('click', '#bet-200', function () {
            $('#betting-btn').val(parseFloat(this.dataset.value).toFixed(2));
        });
        $('body').on('click', '#bet-400', function () {
            $('#betting-btn').val(parseFloat(this.dataset.value).toFixed(2));
        });
        $('body').on('click', '.clickable-ball', function () {
            self.chosenBalls.add(this);
            self.updateMinBet();
        });
        $('body').on('click', '#random-six-button', function () {
            self.chosenBalls.addRandomSix();
            self.updateMinBet();
        });
        $('body').on('click', '#all-colors-button', function () {
            self.chosenBalls.allColors();
            self.updateMinBet();
        });
        $('body').on('click', '#hot-six-button', function () {
            self.chosenBalls.addBalls(window['hot-numbers']);
            self.updateMinBet();
        });
        $('body').on('click', '#cold-six-button', function () {
            self.chosenBalls.addBalls(window['cold-numbers']);
            self.updateMinBet();
        });
        $('body').on('click', '.ticket-ball-choosen', function () {
            self.chosenBalls.remove(this);
            self.updateMinBet();
        });
        $('body').on('click', '#clear-bets', function () {
            self.clearBets();
            self.updateMinBet();
        });
        $('body').on('click', '.top-color', function () {
            $(this).toggleClass('bhr-balls-choosen bhr-balls-choosen-' + this.dataset.color);
            if ($(this).hasClass('bhr-balls-choosen')) {
                self.setTopColor(this.dataset.color);
            }
            else {
                self.unsetTopColor(this.dataset.color);
            }
            self.updateMinBet();
        });
        $('body').on('click', '#more-odd', function () {
            $('#more-even').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.ballParity = 2;
            }
            else {
                self.ballParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#more-even', function () {
            $('#more-odd').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.ballParity = 1;
            }
            else {
                self.ballParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#first5lessthan122', function () {
            $('#first5morethan122').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.first5Sum = 1;
            }
            else {
                self.first5Sum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#first5morethan122', function () {
            $('#first5lessthan122').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.first5Sum = 2;
            }
            else {
                self.first5Sum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '.first-ball-color', function () {
            $(this).toggleClass('bhr-balls-choosen bhr-balls-choosen-' + this.dataset.color);
            if ($(this).hasClass('bhr-balls-choosen')) {
                self.setFirstBallColor(this.dataset.color);
            }
            else {
                self.unsetFirstBallColor(this.dataset.color);
            }
            self.updateMinBet();
        });
        $('body').on('click', '#firstballlessthan24', function () {
            $('#firstballmorethan24').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.firstBallSum = 1;
            }
            else {
                self.firstBallSum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#firstballmorethan24', function () {
            $('#firstballlessthan24').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.firstBallSum = 2;
            }
            else {
                self.firstBallSum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '.last-ball-color', function () {
            $(this).toggleClass('bhr-balls-choosen bhr-balls-choosen-' + this.dataset.color);
            if ($(this).hasClass('bhr-balls-choosen')) {
                self.setLastBallColor(this.dataset.color);
            }
            else {
                self.unsetLastBallColor(this.dataset.color);
            }
            self.updateMinBet();
        });
        $('body').on('click', '#firstballodd', function () {
            $('#firstballeven').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.firstBallParity = 2;
            }
            else {
                self.firstBallParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#firstballeven', function () {
            $('#firstballodd').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.firstBallParity = 1;
            }
            else {
                self.firstBallParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#lastballodd', function () {
            $('#lastballeven').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.lastBallParity = 2;
            }
            else {
                self.lastBallParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#lastballeven', function () {
            $('#lastballodd').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.lastBallParity = 1;
            }
            else {
                self.lastBallParity = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#lastballlessthan24', function () {
            $('#lastballmorethan24').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.lastBallSum = 1;
            }
            else {
                self.lastBallSum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#lastballmorethan24', function () {
            $('#lastballlessthan24').removeClass('betting-btn-chosen');
            $(this).toggleClass('betting-btn-chosen');
            if ($(this).hasClass('betting-btn-chosen')) {
                self.lastBallSum = 2;
            }
            else {
                self.lastBallSum = 0;
            }
            self.updateMinBet();
        });
        $('body').on('click', '#amount-up', function () {
            var input = $('#betting-btn');
            if (input !== undefined) {
                var value = $(input).val();
                var max = $(input).attr('max');
                if (value !== undefined && max !== undefined) {
                    value = parseFloat(value.toString());
                    var step = $(input).attr('step');
                    if (step !== undefined) {
                        if (value + parseFloat(step) <= parseFloat(max)) {
                            $(input).val((value + parseFloat(step)).toFixed(2));
                        }
                        else {
                            $(input).val(parseFloat(max).toFixed(2));
                        }
                    }
                }
            }
        });
        $('body').on('click', '#amount-down', function () {
            var input = $('#betting-btn');
            if (input !== undefined) {
                var value = $(input).val();
                var min = $(input).attr('min');
                if (value !== undefined && min !== undefined) {
                    value = parseFloat(value.toString());
                    var step = $(input).attr('step');
                    if (step !== undefined) {
                        if (value - parseFloat(step) > parseFloat(min)) {
                            $(input).val((value - parseFloat(step)).toFixed(2));
                        }
                        else {
                            $(input).val(parseFloat(min).toFixed(2));
                        }
                    }
                }
            }
        });
    };
    TicketOptions.prototype.updateMinBet = function () {
        var combinations = 0;
        var ticket = {
            'SessionID': window['token'],
            'TicketAmount': this.getAmount(),
            'DrawsCount': 1,
            'SelectedNumbers': this.getChosenBalls().getBalls(),
            'First5Sum': this.getFirst5Sum(),
            'BallParity': this.getBallParity(),
            'BallSum': 0,
            'FirstBallParity': this.getFirstBallParity(),
            'FirstballSum': this.getFirstBallSum(),
            'LastBallParity': this.getLastBallParity(),
            'LastBallSum': this.getLastBallSum(),
            'TopColor': this.getTopColor(),
            'FirstColor': this.getFirstBallColor(),
            'LastColor': this.getLastBallColor()
        };
        var rules = {
            6: 1,
            7: 7,
            8: 28,
            9: 84,
            10: 210,
            48: 8
        };
        if (Object.keys(ticket.SelectedNumbers).length >= 6) {
            combinations = rules[Object.keys(ticket.SelectedNumbers).length];
        }
        if (ticket.First5Sum != 0) {
            combinations++;
        }
        if (ticket.BallParity != 0) {
            combinations++;
        }
        if (ticket.FirstBallParity != 0) {
            combinations++;
        }
        if (ticket.FirstballSum != 0) {
            combinations++;
        }
        if (ticket.LastBallParity != 0) {
            combinations++;
        }
        if (ticket.LastBallSum != 0) {
            combinations++;
        }
        if (ticket.TopColor != '') {
            combinations++;
        }
        if (ticket.FirstColor != '') {
            combinations++;
        }
        if (ticket.LastColor != '') {
            combinations++;
        }
        var minBetPerTicket;
        if (ticket['SelectedNumbers'].length > 10) {
            minBetPerTicket = window['allColorsMinBet'];
        }
        else {
            minBetPerTicket = (parseFloat(window['Bingo_MinBetCombination']) * combinations);
        }
        if (minBetPerTicket < parseFloat(window['Bingo_MinBet'])) {
            minBetPerTicket = window['Bingo_MinBet'];
        }
        else { }
        if ('undefined' !== typeof $('#betting-btn').val()) {
            var currentBet = $('#betting-btn').val();
            if (parseFloat(currentBet) < parseFloat(minBetPerTicket.toFixed(2))) {
                $('#betting-btn').val(parseFloat(minBetPerTicket.toFixed(2)).toFixed(2));
            }
            $('#betting-btn').attr('min', parseFloat(minBetPerTicket.toFixed(2)));
        }
    };
    return TicketOptions;
}());
exports.default = TicketOptions;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/ticket-options.ts
// module id = 1167
// module chunks = 2